import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

/**
 * Service des themes
 */
@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    constructor(@Inject(DOCUMENT) private document: Document) { }
    // Environnement local
    //
    //loadTheme(themeName: string) {
    //    const head = this.document.getElementsByTagName('head')[0] as HTMLElement
    //    const themeSrc = this.document.getElementById('client-theme') as HTMLLinkElement
    //    themeName === 'inpost' ? this.changeFavicon() : ""

    //    if (themeSrc) {
    //        themeSrc.href = `/Scripts/angular/assets/themes/themes-input/${themeName}.css`
    //    } else {
    //        const style = this.document.createElement('link') as HTMLLinkElement
    //        style.id = 'client-theme'
    //        style.rel = 'stylesheet'
    //        style.href = `/Scripts/angular/assets/themes/themes-input/${themeName}.css`

    //        head.appendChild(style)
    //    }
    //}

    //changeFavicon() {
    //    const targetFav = document.getElementById('favicon') as HTMLLinkElement
    //    const targetShortFav = document.getElementById('shortcutFavicon') as HTMLLinkElement
    //    targetFav.href = "/Scripts/angular/assets/img/favicon-inpost.ico"
    //    targetShortFav.href = "/Scripts/angular/assets/img/favicon-inpost.ico"
    //}


    // Environnement preview / prod
    //
    loadTheme(themeName: string) {
        const head = this.document.getElementsByTagName('head')[0] as HTMLElement
        const themeSrc = this.document.getElementById('client-theme') as HTMLLinkElement
        themeName === 'inpost' ? this.changeFavicon() : ""

        if (themeSrc) {
            themeSrc.href = `/Scripts/dist/assets/themes/themes-input/${themeName}.css`
        } else {
            const style = this.document.createElement('link') as HTMLLinkElement
            style.id = 'client-theme'
            style.rel = 'stylesheet'
            style.href = `/Scripts/dist/assets/themes/themes-input/${themeName}.css`

            head.appendChild(style)
        }
    }

    changeFavicon() {
        const targetFav = document.getElementById('favicon') as HTMLLinkElement
        const targetShortFav = document.getElementById('shortcutFavicon') as HTMLLinkElement
        targetFav.href = "/Scripts/dist/assets/img/favicon-inpost.ico"
        targetShortFav.href = "/Scripts/dist/assets/img/favicon-inpost.ico"
    }
}
